import React, { useState, useCallback } from 'react';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons/faExternalLink';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';

import styles from './jobPostingItemStyles';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Link from 'buyside/components/presentation/Link/link';
import Modal from 'buyside/components/presentation/Modal/modal';

import { jobVaultPostingUrl } from 'buyside/util/urlHelper';

const JobPostingItem = ({ node, currentUser }) => {
  const [isDescriptionModalOpen, setIsDescriptionModalOpen] = useState(false);

  const { id, title, description, sectors, postedAt, city, employer } = node;
  const parsedSectors = JSON.parse(sectors);

  const getsButton =
    currentUser.isAdmin ||
    (currentUser.jobPostsAppliedIds && currentUser.jobPostsAppliedIds.includes(id)) ||
    currentUser.jobPostingIds.includes(id);

  const renderOpenDescriptionModalButton = useCallback(
    () => (
      <Button
        className={styles.viewDescriptionButton}
        faIcon={faEye}
        onClick={() => setIsDescriptionModalOpen(true)}
        text="View Description"
        type={BUTTON_TYPES.LINK}
      />
    ),
    []
  );

  return (
    <div className={styles.jobPostingItem}>
      <div className={styles.itemHeader}>
        <div className={styles.headerInfo}>
          <Link className={styles.jobPostingTitle} to={jobVaultPostingUrl(id)}>
            {title}
          </Link>
          <div className={styles.headerSectors}>
            <strong>Sectors: </strong>
            {parsedSectors.length ? parsedSectors.join(' \u2022 ') : 'N/A'}
          </div>
        </div>
        <div className={styles.headerTopRight}>
          <div className={styles.headerButtons}>
            <Modal
              isOpen={isDescriptionModalOpen}
              onClose={() => setIsDescriptionModalOpen(false)}
              renderOpenModalButton={renderOpenDescriptionModalButton}
              size="lg"
              title="Job Description"
            >
              <div className={styles.jobDescription}>{description}</div>
              <br />
              <Button
                text="View Posting"
                type={BUTTON_TYPES.PRIMARY}
                url={jobVaultPostingUrl(id)}
              />
            </Modal>
            {getsButton && (
              <div className={styles.buttonArea}>
                <Button
                  className={styles.viewPostingButton}
                  faIcon={faExternalLink}
                  target="_blank"
                  text="View Details"
                  type={BUTTON_TYPES.LINK}
                  url={jobVaultPostingUrl(id)}
                />
              </div>
            )}
          </div>
          <div className={styles.headerDate}>{postedAt} ago</div>
        </div>
      </div>
      <div className={styles.dataPoints}>
        {[
          { title: 'Location', value: city },
          { title: 'Strategy', value: employer.strategy },
          { title: 'Aum Range', value: employer.aumRange },
          { title: 'Firm Type', value: employer.fundType }
        ].map(dataPoint => (
          <div className={styles.dataPoint} key={dataPoint.title}>
            <div className={styles.dataPointName}>{dataPoint.title}</div>
            <div className={styles.dataPointValue}>{dataPoint.value || 'N/A'}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JobPostingItem;
